module.exports = __webpack_public_path__ + "img/xiexiaoming.8f437540.png";